import script from "./BannerDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerDetail.vue?vue&type=script&setup=true&lang=js"

import "./BannerDetail.vue?vue&type=style&index=0&id=ad7a2fac&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad7a2fac"]])

export default __exports__